export default "__VITE_ASSET__BXlLO16q__"